import { render, staticRenderFns } from "./ProductCaroussel.vue?vue&type=template&id=153a461e&scoped=true"
import script from "./ProductCaroussel.vue?vue&type=script&lang=js"
export * from "./ProductCaroussel.vue?vue&type=script&lang=js"
import style0 from "./ProductCaroussel.vue?vue&type=style&index=0&id=153a461e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153a461e",
  null
  
)

export default component.exports